export default {"src":"https://cdn.sa-tech.de/homeone/main/_next/static/media/logo-hermes.53a54f93.svg","height":40,"width":100,"blurWidth":0,"blurHeight":0};